import { IAppState } from '../../redux';
import { EBetPositionStatus } from '../../redux/reducers';

export function selectBetPositionStatus(state: IAppState): EBetPositionStatus {
  const {
    betPosition: { status },
  } = state;

  return status;
}
